/**
 * Стабильные ключи TanStack Query для объектов и связанных сущностей.
 * Инвалидация узкими ключами снижает лишние refetch.
 */

export const objectQueryKeys = {
  list: () => ["objects"] as const,
  detail: (objectId: number) => ["objects", objectId] as const,
  geometries: (objectId: number) => ["objects", objectId, "geometries"] as const,
  files: (objectId: number) => ["objects", objectId, "files"] as const,
  /** Содержимое папки filestore (корень: null) */
  filestoreNodes: (objectId: number, parentId: number | null) =>
    ["objects", objectId, "filestore", "nodes", parentId === null ? "root" : parentId] as const,
};
